// Avisos por cima da tela x barra de baixo (dono, 16/10/2026).
//
// O tutorial e as janelas fecham quando a pessoa toca no fundo escuro. Se esse
// toque cai em cima de um botão da barra de baixo (Chat, Locações…), antes só
// fechava o aviso — "cliquei e não foi". Agora fecha o aviso E abre a aba.

const SELETOR_BOTAO_BARRA = 'nav[data-visivel] button';

export const botaoDaBarraNoPonto = (x, y) => {
  if (typeof document === 'undefined' || typeof document.elementsFromPoint !== 'function') return null;
  for (const el of document.elementsFromPoint(x, y)) {
    const b = el.closest ? el.closest(SELETOR_BOTAO_BARRA) : null;
    if (b) return b;
  }
  return null;
};

/** Chamar no clique do fundo escuro de um aviso, junto com o fechamento dele. */
export const repassarToqueParaBarra = (evento) => {
  const x = evento?.clientX;
  const y = evento?.clientY;
  if (typeof x !== 'number' || typeof y !== 'number') return;
  const botao = botaoDaBarraNoPonto(x, y);
  if (botao) setTimeout(() => botao.click(), 0); // depois de o aviso sair
};
